import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiPathEnum } from '../constants/endpoints.enum';
import { ApiResponse } from '../interfaces/api-response.inteface';
import {
  BotWithdrawalDispatch,
  OperableBank,
  SendToBotRequest,
} from '../interfaces/bot-withdrawal.interface';

@Injectable({
  providedIn: 'root',
})
export class BotWithdrawalService {
  private API_URL = `${environment.API_URL}${ApiPathEnum.BotWithdrawal}`;

  constructor(private http: HttpClient) {}

  getOperableBanks(): Observable<ApiResponse<OperableBank[]>> {
    return this.http.get<ApiResponse<OperableBank[]>>(
      `${this.API_URL}/operable-banks`,
    );
  }

  sendToBot(
    solicitudId: number,
    interbancaria = false,
    bancoDestinoId?: number,
  ): Observable<ApiResponse<BotWithdrawalDispatch>> {
    const body: SendToBotRequest = {
      solicitudId,
      interbancaria,
      bancoDestinoId,
    };

    return this.http.post<ApiResponse<BotWithdrawalDispatch>>(
      `${this.API_URL}/send-to-bot`,
      body,
    );
  }
}
